import {
  Button,
  ComponentStyle,
  Form,
  Formik,
  FormikControl,
  useRef,
  useRouter,
  CloseWhite,
  Image,
  PageStyle,
  Checkbox,
  CommunicationFilterAction,
  CONSTANT,
  clearSWRCache,
  useEffect,
  useState,
  useSWR,
  useTranslation,
  DefaultCheckbox,
  HoverCheckbox,
  CheckedCheckbox
} from "@/imports-files/components/model/communication-filter";
import Modal from "../common-modal/modal";
import { FormModalStyle } from "@/imports-files/components/review-email";
export function CommunicationFilter(props) {
  const {t} = useTranslation()
  clearSWRCache("communication_filter_data");
  const router = useRouter();
  const formRef = useRef();
  const [isLoading, setIsLoading] = useState(true);
  const [initialValues, setInitialValues] = useState();
  const communicationAction = new CommunicationFilterAction(
    router,
    props.setCommunicationFilter,
    props.communicationFilter,
    props.setFlagForRerender,
    props.setCommunicationList,
    formRef
  );
  const { data, error } = useSWR("communication_filter_data", () => {
    return communicationAction.getDropdownOptions();
  });

  useEffect(() => {
    if (data) {
      setInitialValues(
        communicationAction.isFilterApplied()
          ? router.query
          : CONSTANT.initialValue
      );
      setIsLoading(false);
    }
  }, [data]);
  if (isLoading) {
    return "";
  }

  return (
    <Modal
      type="form"
      heading={t('modal:filter:heading')}
      closeModal={(event) => {
        communicationAction.closeModal();
      }}
      content={
        <Formik
          initialValues={initialValues}
          innerRef={formRef}
          onSubmit={(values) => {
            communicationAction.submitForm(values);
          }}
        >
          {(formik) => (
            <Form className={ComponentStyle.Form}>
              <div
                className={
                  `${FormModalStyle.Modal__Container__ContentSection__Block} ${PageStyle.Form__TableCol}`
                }
              >
                <label
                  className={
                    `${FormModalStyle.Modal__Container__ContentSection__Block__Heading} ${PageStyle.Form__FloatingLabel}`
                  }
                >
                 {t('modal:filter:comms:job_titles')}
                </label>
                <FormikControl
                  className={`${ComponentStyle.Form__CustomSelect} ${PageStyle.Form__CustomSelect} mmt0`}
                  control="select"
                  type="text"
                  placeholder={t('placeholder:select:job_title')}
                  name="job_title"
                  default={formik.values.job_title}
                  onChange={(value) => {
                    communicationAction.handleDropdownChange(
                      "job_title",
                      value
                    );
                  }}
                  options={data.job_options}
                />
              </div>
              <div
                className={
                  `${FormModalStyle.Modal__Container__ContentSection__Block} ${PageStyle.Form__TableCol}`
                }
              >
                <label
                  className={
                    `${FormModalStyle.Modal__Container__ContentSection__Block__Heading} ${PageStyle.Form__FloatingLabel}`
                  }
                >
                 {t('modal:filter:comms:candidate_name')}
                </label>
                <FormikControl
                  className={`${ComponentStyle.Form__CustomSelect} ${PageStyle.Form__CustomSelect} mmt0`}
                  control="select"
                  type="text"
                  placeholder={t('placeholder:select:job_candidate')}
                  name="candidate_name"
                  default={communicationAction.setDefaultValueDropdown(
                    data.candidate_options,
                    formik.values.candidate_name
                  )}
                  options={data.candidate_options}
                  onChange={(value) => {
                    communicationAction.handleDropdownChange(
                      "candidate_name",
                      value
                    );
                  }}
                />
              </div>

              <div className={` ${ComponentStyle.Form__TableRowBlock} mb16`}>
                <div className={ComponentStyle.Form__TableCol2}>
                  <div className={`${ComponentStyle.Form__LabelCheck} Dpflex16 Mui__CustomCheckbox`}>
                    <Checkbox
                      defaultChecked={formik.values.non_interview}
                      icon = {<DefaultCheckbox/>}
                      checkedIcon = {<CheckedCheckbox/>}
                      name="non_interview"
                      onChange={(event) => {
                        communicationAction.handleCheckboxChange(
                          "non_interview",
                          event
                        );
                      }}
                    />{" "}
                    {t('modal:filter:comms:non_interview_emails')}
                  </div>
                </div>
              </div>

              <div className={` ${ComponentStyle.Form__TableRowBlock} mt0`}>
                <div className={ComponentStyle.Form__TableCol2}>
                  <div className={`${ComponentStyle.Form__LabelCheck} Dpflex16 Mui__CustomCheckbox`}>
                    <Checkbox
                      defaultChecked={formik.values.important}
                      icon = {<DefaultCheckbox/>}
                      checkedIcon = {<CheckedCheckbox/>}
                      name="important"
                      onChange={(event) => {
                        communicationAction.handleCheckboxChange(
                          "important",
                          event
                        );
                      }}
                    />{" "}
                     {t('modal:filter:comms:important_emails')}
                  </div>
                </div>
              </div>
              <div className="height113" />
              <div className={FormModalStyle.Modal__Container__ButtonSection}>
                <Button
                  buttonstyle={ComponentStyle.secondarybtn}
                  onClick={() => {
                    communicationAction.resetForm();
                  }}
                >
                  {t('button:reset')}
                </Button>
                <Button buttonstyle={ComponentStyle.primarybtn} type="submit">
                {t('button:apply')}
                </Button>
              </div>
            </Form>
          )}
        </Formik>
      }
    />
  );
}
